import { render } from "./EventReward.vue?vue&type=template&id=6ff5b189&scoped=true"
import script from "./EventReward.vue?vue&type=script&lang=js"
export * from "./EventReward.vue?vue&type=script&lang=js"

import "./EventReward.vue?vue&type=style&index=0&id=6ff5b189&scoped=true&lang=scss"

import exportComponent from "/home/forge/hostess.posnania.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff5b189"]])

export default __exports__